module.exports = __webpack_public_path__ + "lemon_vue/img/qrcode.7b00665.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/qrcode.png
// module id = 6y1M
// module chunks = 1